/* eslint-disable */
import { createApp, watch } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/tailwind.css';
import './assets/styles.css';
import i18n from './i18n';
import 'flag-icons/css/flag-icons.min.css';
import VueGtag from 'vue-gtag';

const app = createApp(App);

watch(
  () => [i18n.global.locale.value, router.currentRoute.value.meta.titleKey],
  ([locale, titleKey]) => {
    const { t } = i18n.global;
    document.documentElement.lang = locale === 'bz' ? 'pt-BR' : locale;
    if (titleKey) document.title = t(titleKey);
    document.querySelector('meta[property="og:title"]')?.setAttribute('content', t(titleKey || 'title.home'));
    for (const selector of ['meta[name="description"]', 'meta[property="og:description"]']) {
      document.querySelector(selector)?.setAttribute('content', t('description'));
    }
  },
  { immediate: true }
);

// Подключаем Google Analytics
app.use(VueGtag, {
  config: { id: 'G-RZJCFN0FG5' }
});

app.use(router).use(i18n).mount('#app');
